export const ReferenceToCuboid = {
    kind: "Reference",
    template: "Cuboid",
};
